import React, { useEffect, useState } from "react";

function WalletNot() {
  return (
    <div className="menu_m">
      <p
        style={{
          color: "white",
          fontSize: "50px",
          textAlign: "center",
          marginTop: "200px",
        }}
      >
        <b>Wallet not connected</b>
        <br />
        <span>
          <a href="/">Connect Now !</a>
        </span>
      </p>
    </div>
  );
}

export default WalletNot;
